export default "__VITE_ASSET__BlyGTwME__"